export const POSchema = [
  {
    nameKey: "Supplier :",
    valueKey: "Supplier",
  },
  {
    nameKey: "Delivery Terms :",
    valueKey: "DeliveryTerms",
  },
  {
    nameKey: "Payment Terms :",
    valueKey: "PaymentTerms",
  },
  {
    nameKey: "Due Date :",
    valueKey: "DueDate",
  },
];
